export default "__VITE_ASSET__BmPJNXdN__"